import { getPlatformIcon } from '@/components/creator-discovery/utils/creator-formatters';
import CreatorAvatar from '@/components/creators/CreatorAvatar';
import { useInvitationStoreSelector } from '@/contexts/invitation-context';
import { Box, Button, Flex, Text, VStack } from '@chakra-ui/react';
import { PlatformEnum } from '@fluenceur/types';
import { useTranslation } from 'react-i18next';
import { LockedValue } from '@/components/plan-locks/LockedValue';
import { isIdentityLocked } from '@/components/plan-locks/creator-locks';

const PLATFORM_LABELS: Record<string, string> = {
  [PlatformEnum.Instagram]: 'Instagram',
  [PlatformEnum.TikTok]: 'TikTok',
};

export const CreatorInfoHeader = () => {
  const { t } = useTranslation();
  const creator = useInvitationStoreSelector((state) => state.creator);
  // A prospect the plan masks comes without name, handle or profile link.
  const name = creator?.name || t('planLocks.name');

  const platformLabel = creator?.platform
    ? (PLATFORM_LABELS[creator.platform.toLowerCase()] ?? creator.platform)
    : '';
  const avatarCreatorId =
    creator?.platform.toLowerCase() === PlatformEnum.Instagram && creator.username
      ? creator.username
      : undefined;

  return (
    <Flex align="center" gap={3}>
      <CreatorAvatar
        creatorId={avatarCreatorId}
        creatorName={name}
        fallbackSrc={creator?.profilePictureUrl || undefined}
        lazyFetch={Boolean(avatarCreatorId && creator?.profilePictureUrl)}
        size="md"
      />
      <VStack align="start" gap={0}>
        <Text fontWeight="600">{name}</Text>
        <Text fontSize="sm" color="gray.500">
          {isIdentityLocked(creator) ? (
            <LockedValue label={t('planLocks.handle')} />
          ) : creator?.username ? (
            `@${creator.username}`
          ) : null}
        </Text>
      </VStack>
      {creator?.profileUrl && (
        <Box ml="auto">
          <Button variant="outline" colorPalette="gray" size="sm" asChild>
            <a href={creator.profileUrl} target="_blank" rel="noreferrer">
              {getPlatformIcon(creator.platform)}
              See profile on {platformLabel}
            </a>
          </Button>
        </Box>
      )}
    </Flex>
  );
};
